import React from 'react';
import LegalLayout, { LegalSection } from './LegalLayout';

const EMAIL = 'aryanshivhare004@gmail.com';

const CookiePolicy = () => {
  return (
    <LegalLayout
      title="Cookie Policy"
      lastUpdated="June 2026"
      canonical="https://aryanshivhare.com/cookie-policy"
      description="Cookie Policy for aryanshivhare.com — what cookies we use, why we use them, and how you can manage your preferences (GDPR compliant)."
    >
      <p>
        This Cookie Policy explains how aryanshivhare.com (the &ldquo;Site&rdquo;) uses cookies and similar
        technologies. It should be read alongside our Privacy Policy. By continuing to use the Site,
        or by accepting cookies via our consent banner, you agree to the use of cookies as described
        below.
      </p>

      <LegalSection heading="What Are Cookies?">
        <p>
          Cookies are small text files placed on your device when you visit a website. They help the
          site function properly, remember your preferences, and provide information to the site
          owner. Cookies can be &ldquo;session&rdquo; cookies (deleted when you close your browser) or
          &ldquo;persistent&rdquo; cookies (which remain until they expire or you delete them).
        </p>
      </LegalSection>

      <LegalSection heading="Types of Cookies We Use">
        <ul className="list-disc pl-6 space-y-3">
          <li>
            <strong className="text-white">Essential cookies</strong> — required for the Site to
            function, such as remembering your cookie consent choice and your selected language.
          </li>
          <li>
            <strong className="text-white">Analytics cookies</strong> — help us understand how
            visitors use the Site (pages visited, time spent) so we can improve content and
            performance. This data is aggregated and anonymous.
          </li>
          <li>
            <strong className="text-white">Advertising cookies</strong> — set by Google AdSense and
            its partners to deliver relevant ads and measure their performance.
          </li>
        </ul>
      </LegalSection>

      <LegalSection heading="Google AdSense Cookies">
        <p>
          We use Google AdSense to display advertisements. Google and its partners use cookies to
          serve ads based on your prior visits to this and other websites.
        </p>
        <ul className="list-disc pl-6 space-y-2">
          <li>
            Third-party vendors, including Google, use cookies to serve ads based on your past
            visits to the Site.
          </li>
          <li>
            You can opt out of personalized advertising by visiting{' '}
            <a
              href="https://www.google.com/settings/ads"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gold underline underline-offset-4 hover:opacity-70"
            >
              Google Ads Settings
            </a>
            , or opt out of third-party vendor cookies at{' '}
            <a
              href="https://www.aboutads.info"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gold underline underline-offset-4 hover:opacity-70"
            >
              www.aboutads.info
            </a>
            .
          </li>
        </ul>
      </LegalSection>

      <LegalSection heading="Managing Your Cookie Preferences">
        <p>
          When you first visit the Site, a consent banner lets you accept or decline non-essential
          cookies. You can change your choice at any time by clearing your browser&rsquo;s site data for
          this Site, which will prompt the banner to appear again.
        </p>
        <p>
          You can also control cookies directly through your browser settings — most browsers allow
          you to block or delete cookies. Note that disabling certain cookies may affect how the
          Site functions.
        </p>
      </LegalSection>

      <LegalSection heading="Your Consent (GDPR)">
        <p>
          For visitors in the European Union, we rely on your consent to set non-essential cookies,
          in line with the GDPR and ePrivacy regulations. You may withdraw your consent at any time.
        </p>
      </LegalSection>

      <LegalSection heading="Changes to This Policy">
        <p>
          We may update this Cookie Policy from time to time. Any changes will be posted on this page
          with an updated &ldquo;Last updated&rdquo; date.
        </p>
      </LegalSection>

      <LegalSection heading="Contact Us">
        <p>
          If you have any questions about our use of cookies, contact us at{' '}
          <a href={`mailto:${EMAIL}`} className="text-gold underline underline-offset-4 hover:opacity-70">
            {EMAIL}
          </a>
          .
        </p>
      </LegalSection>
    </LegalLayout>
  );
};

export default CookiePolicy;
